import React from 'react';
import { futureUseConditions, futureUses, type FutureUseArea } from '../../data/siteContent';
type FutureUsesProps = {
  area: FutureUseArea;
  /** Use on navy bands. */
  tone?: 'light' | 'dark';
  className?: string;
};

/** Proposed future uses, clearly separated from what the demos do today. */
export function FutureUses({
  area,
  tone = 'light',
  className = ''
}: FutureUsesProps) {
  const group = futureUses[area];
  const dark = tone === 'dark';
  return <aside aria-label={group.title} className={`rounded-lg border p-6 lg:p-7 ${dark ? 'border-white/20 bg-white/5 text-white' : 'border-line bg-surface-bg text-ink-dark'} ${className}`} data-id="element-1395" data-mp="23xc12392z8">
      <p className={`text-sm font-medium ${dark ? 'text-teal' : 'text-teal'}`} data-id="element-1396" data-mp="3iacvfc3t110n">Proposed · not in current demos</p>
      <h3 className="mt-1 font-heading font-bold text-lg" data-id="element-1397" data-mp="2ax13ae3refhu">{group.title}</h3>
      <ul className={`mt-4 space-y-2 ${dark ? 'text-white/85' : 'text-ink-dark'}`} data-id="element-1398" data-mp="26uxphitmayte">
        {group.uses.map(use => <li key={use} className="flex gap-3 leading-relaxed" data-id="element-1399" data-mp="3u455jp73ebkd">
            <span aria-hidden="true" className={`mt-2.5 h-1 w-3 shrink-0 ${dark ? 'bg-white/40' : 'bg-ink-muted/50'}`} data-id="element-1400" data-mp="3u2tztju36tqm" />
            {use}
          </li>)}
      </ul>
      <p className={`mt-4 text-sm leading-relaxed ${dark ? 'text-white/70' : 'text-ink-muted'}`} data-id="element-1401" data-mp="3l3f86h26od4j">{group.conditions}</p>
      <p className={`mt-2 text-sm leading-relaxed ${dark ? 'text-white/70' : 'text-ink-muted'}`} data-id="element-1402" data-mp="3p7n0eo7uob7i">{futureUseConditions}</p>
    </aside>;
}